import { render, staticRenderFns } from "./imgX.vue?vue&type=template&id=378b8a1f"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('378b8a1f')) {
      api.createRecord('378b8a1f', component.options)
    } else {
      api.reload('378b8a1f', component.options)
    }
    module.hot.accept("./imgX.vue?vue&type=template&id=378b8a1f", function () {
      api.rerender('378b8a1f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/staffCardPlaceholdersNew/imgX.vue"
export default component.exports